// @flow

import type { Process } from '@gandi/cart';
import type {
  ContactRole,
  ContactType,
  FavoriteContact,
} from '@gandi/redux-resource-contactbook';
import type { TranslatorProps } from '@gandi/translate';

import type { CreateOrTransfer } from '../types';

export const getModifyContactUrl = (
  cartId: string,
  process: CreateOrTransfer,
  role: string,
): string => `/cart/${cartId}/configure/setup/role-contact/${role}/${process}`;

export const getSetupOverviewUrl = (
  cartId: string,
  process?: Process | CreateOrTransfer,
): string =>
  process
    ? `/cart/${cartId}/configure/setup/overview/${process}`
    : `/cart/${cartId}/configure/setup/`;

export const getDisplayedRole = (
  { __ }: TranslatorProps,
  role: ContactRole,
): string => {
  const names = {
    owner: __('Owner Contact'),
    admin: __('Administrative Contact'),
    tech: __('Technical Contact'),
    bill: __('Billing Contact'),
  };

  return names[role];
};

export const getDisplayedDomainProduct = (
  { __ }: TranslatorProps,
  process: CreateOrTransfer,
): string => {
  const names = {
    create: __('Domains Registrations'),
    transfer: __('Domains Transfer'),
  };

  return names[process];
};

const types = ['individual', 'publicbody', 'association', 'company'] as const;

export const getDisplayedType = (
  { __ }: TranslatorProps,
  type: ContactType,
): string => {
  const names = {
    individual: __('Individual'),
    publicbody: __('Public Body'),
    association: __('Association'),
    company: __('Company'),
  };

  return names[type] || names[types[parseInt(type, 10)]];
};

export const getDisplayName = ({
  type,
  orgname = '',
  given = '',
  family = '',
}: FavoriteContact): string =>
  ['individual', '0'].includes(type) ? `${given} ${family}` : orgname;
